import { useEffect } from "react";

const useInjectScript = (code: string) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = code;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [code]);
};

export default useInjectScript;
